import Client from '@/client'

export default {
  token(payload) {
    return Client.post(`token/`, payload)
  },
  otp(id) {
    return Client.get(`otp/${id}/`)
  },
  login(id, payload) {
    return Client.post(`otp/${id}/`, payload)
  },
}